import { inject } from '@angular/core';

import { HrAssistantWalkthroughDialogComponent } from '@core/intelligence-ui';
import { DialogService, DialogWidth } from '@core/user-interface-legacy';

export const injectHrAssistantWalkthroughDialogOpener = () => {
  const dialogSvc = inject(DialogService);
  return (canManage: boolean) =>
    dialogSvc.openDialog(
      HrAssistantWalkthroughDialogComponent,
      {
        canManage,
      },
      {
        width: DialogWidth.Small,
      },
    );
};
